import { get, uniq } from 'lodash';
import { SectionType } from '../../types';
import { mixColumn, mixColumnNoWrap, mixLeftColumn, mixRightColumn, mixSpacer, mixSectionNoWrap, mixButton, mixImageWrapperFullWidth, mixImageWithPadding, } from '../../sections/mix-css-classes';
import { getRegionSpacing } from '../get-section-padding';
const TINY_WIDTH_PADDING = 12;
export function getHardCapMixColumnPaddingsForSmallScreenCss({ css }) {
    const sectionSpacingObject = getRegionSpacing(css, SectionType.mix);
    return `
  .${mixLeftColumn} > table > tbody > tr > td {
    padding-top: ${Math.min(sectionSpacingObject.padding.top, 24)}px!important;
  }

  .${mixRightColumn} > table > tbody > tr > td {
    padding-bottom: ${Math.min(sectionSpacingObject.padding.bottom, 24)}px!important;
  }
  `;
}
export function getMixColumnPaddingsForSmallScreenCss({ css }) {
    const spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    return `
  .${mixColumn} > table > tbody > tr > td,
  .${mixColumnNoWrap} > table > tbody > tr > td,
  .${mixLeftColumn} > table > tbody > tr > td,
  .${mixRightColumn} > table > tbody > tr > td {
    padding: 0!important;
  }

  .${mixLeftColumn} {
    padding-bottom: ${spacerHeight}px!important;
  }

  .${mixSpacer} div {
    height: ${spacerHeight}px!important;
  }
  `;
}
export function getMixImageMaxWidthForSmallScreenCss() {
    return `
    .${mixLeftColumn} img,
    .${mixRightColumn} img {
      max-width: none !important;
      width: 100% !important;
    }
  `;
}
export function getSmallScreenMixImageFullWidthCss() {
    return `
    .${mixImageWrapperFullWidth} {
      max-width:100%!important;
    }
    .${mixImageWrapperFullWidth} img {
      height: 100%!important;
    }
    .${mixColumn} img {
      max-width: none !important;
      width: 100% !important;
    }
    .${mixImageWithPadding} {
      width:100%!important;
      padding-right: 0!important;
      padding-left: 0!important;
    }
  `;
}
export function getMobileCssForMulticolumnSetup({ css }) {
    const spacerHeight = Math.min(parseInt(get(css, 'so-global-region-mix-separator.marginBottom') || '20px', 10), 20);
    // const mixButtonPadding = utils.padding([css['so-global-b1-mix']]);
    // // arbitrary selected numbers, kind of works even on 25/25/25/25 no wrap split
    // const horizontalLimit = 20;
    // const verticalLimit = 12;
    // const minPadding = {
    //   top: Math.min(mixButtonPadding.top, verticalLimit),
    //   bottom: Math.min(mixButtonPadding.bottom, verticalLimit),
    //   left: Math.min(mixButtonPadding.left, horizontalLimit),
    //   right: Math.min(mixButtonPadding.right, horizontalLimit),
    // };
    // const noWrapButtonPaddingOverride = isEqual(mixButtonPadding, minPadding)
    //   ? ''
    //   : utils.shorthand(minPadding);
    return `
    .${mixLeftColumn},
    .${mixColumn} {
      padding-bottom: ${spacerHeight}px!important;
    }

    .${mixSectionNoWrap} > table > tbody > tr > td {
      padding:0px 12px!important;
    }

    .${mixColumnNoWrap} > table > tbody > tr > td {
      padding: 0px 8px!important;
    }

    .${mixColumnNoWrap}.${mixRightColumn} > table > tbody > tr > td {
      padding-bottom: ${spacerHeight}px!important;
    }
    `;
    // ${
    //   noWrapButtonPaddingOverride &&
    //   `.${mixColumnNoWrap} > table > tbody > tr > td > table > tbody > tr > .${mixButton} > table > tbody > tr > td > a {
    //   padding:${noWrapButtonPaddingOverride}!important;
    // }`
    // }
}
export function getMobileMixMulticolumnCss(region) {
    const columnWidths = uniq(region.layout.rows[0].columns.map(({ width }) => width || 50));
    const multicolumnsButtonWidth = `.${mixSectionNoWrap} .${mixButton} > table > tbody > tr > td > a {
    padding-left: ${TINY_WIDTH_PADDING}px!important;
    padding-right: ${TINY_WIDTH_PADDING}px!important;
  }`;
    return columnWidths
        .map((width) => `.${mixColumnNoWrap}.${mixColumnNoWrap}-${width} {
        width: ${width}%!important;
      }`)
        .concat(multicolumnsButtonWidth)
        .join('');
}
export function getMixSmallScreenCss({ css }) {
    return [
        getMixImageMaxWidthForSmallScreenCss(),
        getMixColumnPaddingsForSmallScreenCss({ css }),
        getHardCapMixColumnPaddingsForSmallScreenCss({ css }),
        getMobileCssForMulticolumnSetup({ css }),
        getSmallScreenMixImageFullWidthCss(),
    ]
        .filter(Boolean)
        .join(' ');
}
export function getMixCss() {
    return `
    .${mixColumnNoWrap} {
      display: inline-block!important;
    }
  `;
}
//# sourceMappingURL=get-mix-section-style.js.map